module.exports = __webpack_public_path__ + "assets/chevron-right-bf0f76.svg";